/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import type { ReactElement } from "react";

import { spacing } from "../../../../../global/emotion";
import type { HallowElementProps } from "../../../../types/hallowElementProps.types";
import { List } from "../List/List.emotion";
import type { OrderedListItemProps } from "../OrderedListItem/OrderedListItem.emotion";

export type OrderedListProps = Omit<HallowElementProps<"ol">, "children"> & {
  children:
    | ReactElement<OrderedListItemProps>
    | ReactElement<OrderedListItemProps>[];
};

const listStyle: Interpolation = {
  alignItems: "flex-start",
  display: "flex",
  flexDirection: "column",
  gap: spacing.none,
  justifyContent: "flex-start",
  listStylePosition: "inside",
  listStyleType: "none",
};

const listTypeStyle: Record<OrderedListProps["type"], Interpolation> = {
  "1": {
    "--style-type": "decimal",
  },
  A: {
    "--style-type": "upper-alpha",
  },
  a: {
    "--style-type": "lower-alpha",
  },
  i: {
    "--style-type": "lower-roman",
  },
  I: {
    "--style-type": "upper-roman",
  },
};

export const OrderedList = ({
  children,
  type = "1",
  ...props
}: OrderedListProps) => {
  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `ol > li::before {
            content: counter(list-item, var(--style-type));
          }`,
        }}
      />
      <List asChild css={[listStyle, listTypeStyle[type]]} {...props}>
        <ol type={type}>{children}</ol>
      </List>
    </>
  );
};
